<template>
	<section class="app-container">
		<div class="container taxonomylist-container" :class="show_hierarchy ? 'hierarchy' : 'flat'">
			<div class="loading-overlay" v-if="loading">
				<div class="spinner-wrapper">
					<span class="spinner-text">LOADING</span>
					<span class="spinner"></span>
				</div>
			</div>
			<div class="pull-right">
				<button class="btn" @click="downloadExcelData()">Download Excel</button>&nbsp;
				<button class="btn" @click="downloadCSVData()">Download CSV</button>
			</div>
			<h1>World Odonata List</h1>
			<hr class="clear" />
			<div class="sticky-top clearfix pull-right">
				<div class="sticky-outter">
					<br />
					<div class="sticky-inner top-taxa-search">
						<label>Search Taxonomy</label>
						<v-select label="plain_name" :options="matched_taxa"  @search="searchTaxa" v-model="selected_taxa" :filterable="false">
							<template slot="no-options">
								Search the World Odonata List
							</template>
							<template slot="option" slot-scope="taxa">
								<span v-html="taxa.display_name_html"></span>
							</template>
						</v-select>
						<label>Search Authors</label>
						<v-select label="plain_name" :options="matched_authors" v-model="selected_author" @search="searchAuthors" :filterable="false">
							<template slot="no-options">
								Search Authors
							</template>
						</v-select>
						<label>Search Years</label>
						<v-select label="plain_name" :options="years" v-model="selected_year">
							<template slot="no-options">
								Search Years
							</template>
						</v-select>
					</div>
				</div>
			</div>
			<div class="odonata-intro" v-html="intro"></div>
			<hr class="search-top" />
			<taxonomy-list-group :flat="!show_hierarchy" groupType="suborders" v-bind:group="taxon_suborders" />
		</div>
		<div class="modal-container wol-details-modal" id="WOLDetailsModal">
			<div class="modal-content modal-content-regular">
				<div class="modal-close modal-close-cross"></div>
				<div class="bg--white border--round ">
					<div class="container">
						<div class="loading-overlay" v-if="modal_loading">
							<div class="spinner-wrapper">
								<span class="spinner-text">LOADING</span>
								<span class="spinner"></span>
							</div>
						</div>
						<div v-if="detail_taxon">
							<h3><em>{{detail_taxon.scientific_name}}</em> Details</h3>
							<dl>
								<dt v-if="detail_taxon.source">Source</dt>
								<dd v-if="detail_taxon.source">{{detail_taxon.source}}</dd>
								<dt v-if="detail_taxon.common_name">Common Name</dt>
								<dd v-if="detail_taxon.common_name">{{detail_taxon.common_name}}</dd>
								<dt v-if="detail_taxon.notes">Notes</dt>
								<dd v-if="detail_taxon.notes">{{detail_taxon.notes}}</dd>
								<dt v-if="detail_taxon.distribution">Region</dt>
								<dd v-if="detail_taxon.distribution">{{detail_taxon.region}}</dd>
								<dt v-if="detail_taxon.distribution">Distribution</dt>
								<dd v-if="detail_taxon.distribution">{{detail_taxon.distribution}}</dd>
							</dl>
							<div v-if="!detail_taxon.source && !detail_taxon.common_name && !detail_taxon.notes && !detail_taxon.region && !detail_taxon.distribution">
								<em>No details available.</em>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		name: 'TaxonomyList',
		metaInfo: {
			title: 'World Odonata List',
			meta: [
				{ name: "description", content: 'World Odonata List' },
				],
		},
		mounted(){
			var self = this;
			self.getData();
			$(document).on('WOLSetAutor', function(e, selection) {
				self.selected_author = selection;
			});
			$(document).on('WOLSetYear', function(e, selection) {
				for (var i = 0; i < self.years.length; i++) {
					if (self.years[i] == selection) {
						self.selected_year = self.years[i];
					}
				}
			});
			$(document).on('WOLSetTaxon', function(e, selection) {
				for (var i = 0; i < self.flat_taxa.length; i++) {
					if (self.flat_taxa[i].scientific_name == selection) {
						self.selected_taxa = self.flat_taxa[i];
					}
				}
			});
			document.addEventListener("modalClosed.modals.mr", function(event) {
				self.setDetailTaxon(null);
			});
		},
		data: function () {
			return {
				taxon_suborders: null,
				taxon_meta: null,
				intro: "",
				search: "",
				flat_taxa: [],
				active_flat_taxa: [],
				authors: [],
				years: [],
				matched_taxa:[],
				matched_authors:[],
				selected_taxa:null,
				selected_author:null,
				selected_year:null,
				loading:true,
				modal_loading:false,
				detail_taxon:null,
			}
		},

		watch: {
			'search': function(val){
				this.apply_filters();
			},
			'selected_taxa': function(val){
				if (!val) {
					this.search = ""
				}
				else{
					this.search = val.display_name_html.replace(/<{1}[^<>]{1,}>{1}/g," ");
				}
			},
			'selected_author': function(val){
				this.apply_filters();
			},
			'selected_year': function(val){
				this.apply_filters();
			}
		},
		methods:{
			showDetails:function(taxon){
				var self = this;
				self.modal_loading = true;
				if (!taxon) {
					return;
				}


				self.API({
					endpoint: 'wol/taxa/'+taxon.id,
					funcThen: function(response){
						mr.modals.showModal($('#WOLDetailsModal'));
						self.detail_taxon = response.data.wol_taxon;
						self.modal_loading = false;
					}
				});
			},
			setDetailTaxon:function(taxon){
				this.detail_taxon = taxon;
			},
			apply_filters:function(){
				var match_functions = [];
				if (this.selected_taxa) {
					match_functions.push(this.matches_selected_taxon);
				}
				if (this.selected_author){
					match_functions.push(this.matches_selected_author);
				}
				if (this.selected_year){
					match_functions.push(this.matches_selected_year);
				}
				this.search_deep(this.taxon_suborders, match_functions);
				this.active_flat_taxa = this.get_active_taxa();
				this.set_authors_and_years();
				this.scrollTo(".search-top");
			},
			searchAuthors:function(search){
				this.matched_authors = [];
				var matched = [];
				for (var i = this.authors.length - 1; i >= 0; i--) {
					if (this.deaccent(this.authors[i]).toLowerCase().startsWith(this.deaccent(search).replace(/\s+/g, '').toLowerCase())) {
						matched.push(this.authors[i]);
					}
				}
				this.matched_authors = matched;
			},
			searchTaxa:function(search){
				this.matched_taxa = [];
				var matched = [];
				for (var i = this.active_flat_taxa.length - 1; i >= 0; i--) {
					if (this.active_flat_taxa[i].type == "species" || this.active_flat_taxa[i].type == "synonyms") {
						continue;
					}
					if (this.matches_selected_taxon(this.active_flat_taxa[i], search)) {
						matched.push({
							display_name_html: this.active_flat_taxa[i].display_name_html,
							plain_name: this.active_flat_taxa[i].plain_name
						});
					}
				}
				this.matched_taxa = matched;
			},
			search_deep:function(target, match_functions){
				for (var i = target.length - 1; i >= 0; i--) {
					target[i].hide = !this.matches_functions(target[i], match_functions);
					var childeren = this.get_childeren_attribute(target[i]);
					target[i].has_childeren = childeren != null;
					if (target[i].hide || !this.show_hierarchy) {
						if (childeren) {
							this.search_deep(childeren, match_functions);
						}
					}
					else if (this.show_hierarchy){
						this.show_ancestors(target[i]);
						this.show_all(childeren);
					}
				}
			},
			matches_functions:function(target, match_functions){
				for (var i = 0; i < match_functions.length; i++) {
					if (!match_functions[i](target)) {
						return false;
					}
				}
				return true;
			},
			show_ancestors: function(taxon){
				if (taxon.parent) {
					taxon.parent.hide = false;
					this.show_ancestors(taxon.parent);
				}
			},
			show_all: function(taxa){
				if (!taxa) {
					return;
				}
				for (var i = taxa.length - 1; i >= 0; i--) {
					taxa[i].hide = false;
					this.show_all(this.get_childeren_attribute(taxa[i]));
				}
			},
			get_childeren_attribute_name: function(taxa){
				for (var prop in taxa) {
					if (Array.isArray(taxa[prop]) && prop != 'parsed_authors') {
						return prop;
					}
				}
				return null;
			},
			get_childeren_attribute: function(taxa){
				var prop = this.get_childeren_attribute_name(taxa);
				if (!prop) {return null;}
				return taxa[prop];
			},
			matches_selected_taxon:function(taxa, search){
				if (!search) {
					search = this.search;
				}
				if (this.deaccent(taxa.search_name).toLowerCase().startsWith(this.deaccent(search).replace(/\s+/g, '').toLowerCase())) {
					return true;
				}
				// if (taxa.parent) {
				// 	return this.matches_selected_taxon(taxa.parent, search);
				// }
				return false;
			},
			deaccent:function(s){
				return s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
			},
			matches_selected_author:function(taxa){
				return taxa.author && this.deaccent(taxa.author).toLowerCase().includes(this.deaccent(this.selected_author).replace(/\s+/g, '').toLowerCase());
			},
			matches_selected_year:function(taxa){
				return taxa.year && taxa.year.toString() == this.selected_year;
			},
			set_authors_and_years: function(){
				this.authors = [];
				this.years = [];

				var as = [];
				var ys = [];
				var delimiters = [',', '&'];
				for (var i = 0; i < this.active_flat_taxa.length; i++) {
					if (!this.active_flat_taxa[i].author) {
						continue;
					}
					var split_authors = this.active_flat_taxa[i].author
					.split(new RegExp(`[${delimiters.join('')}]`))
					.map(item => item.trim()) // Trim whitespace from each element
					.filter(item => item !== ''); // Filter out empty strings

					as = Array.from(new Set(as.concat(split_authors)));

					if (this.active_flat_taxa[i].year && !ys.includes(this.active_flat_taxa[i].year.toString())) {
						ys.push(this.active_flat_taxa[i].year.toString());
					}
				}
				this.authors = as.sort();
				this.years = ys.sort().reverse();
			},
			get_active_taxa: function(){
				var ret = [];
				for (var i = 0; i < this.flat_taxa.length; i++) {
					if(!('hide' in this.flat_taxa[i]) || this.flat_taxa[i].hide == false){
						ret.push(this.flat_taxa[i]);
					}
				}
				return ret;
			},
			set_parents_and_defaults: function(taxa, parent){
				if (!taxa) {
					return;
				}
				for (var i = taxa.length - 1; i >= 0; i--) {
					var tmp = taxa[i];
					taxa[i].parent = parent;
					taxa[i].type = this.get_childeren_attribute_name(parent);
					taxa[i].parsed_authors = this.parse_authors(taxa[i]);
					taxa[i].authors_html = this.join_author_html(taxa[i].parsed_authors);
					taxa[i].display_name_html = this.taxa_build_full_name(taxa[i]);
					taxa[i].plain_name = taxa[i].display_name_html.replace(/<{1}[^<>]{1,}>{1}/g," ");
					taxa[i].search_name = taxa[i].plain_name.replace(/\s+/g, '');
					this.flat_taxa.push(taxa[i]);
					var childeren = this.get_childeren_attribute(taxa[i]);
					this.set_parents_and_defaults(childeren, taxa[i]);
				}
			},
			parse_authors(taxa){
				var delimiters = [',', '&'];
				var parsed_authors = [];

				if (!taxa.author) {
					return parsed_authors;
				}

				var split_authors = taxa.author.split(new RegExp(`[${delimiters.join('')}]`));

				for (var i = 0; i < split_authors.length; i++) {
					if (split_authors[i] != '') {
						var sa = split_authors[i].trim();
						var parsed_author = {
							original_text: sa,
							name_only: sa,
							in_author_name: null,
							template: "{0}"
						};

						if (sa.indexOf(" in ") > -1) {
							parsed_author.name_only = sa.substring(0, sa.indexOf(" in "));
							parsed_author.in_author_name = sa.substring(sa.indexOf(" in ") + 4, sa.length);
							parsed_author.template = parsed_author.original_text;
							parsed_author.template = parsed_author.template.replace(parsed_author.name_only, "{0}")
							parsed_author.template = parsed_author.template.replace(parsed_author.in_author_name, "{1}")
						}

						var parsed_template = parsed_author.template.replace("{0}", "<a class='author-name'>"+parsed_author.name_only+"</a>");
						if (parsed_template.indexOf("{1}") != -1) {
							parsed_template = parsed_template.replace("{1}", "<a class='in-author-name'>"+parsed_author.in_author_name+"</a>")
						}

						parsed_author.element = $("<span><span class=\"wol-author-link\">"+parsed_template+"</span></span>");
						parsed_author.element.find("a.author-name")
							.attr('data-author-name', parsed_author.name_only)
							.attr('href', "javascript:void(0);")
							.attr('onclick', "$(document).trigger('WOLSetAutor',$(this).data('author-name'));");

						parsed_author.element.find("a.in-author-name")
							.attr('data-author-name', parsed_author.in_author_name)
							.attr('href', "javascript:void(0);")
							.attr('onclick', "$(document).trigger('WOLSetAutor',$(this).data('author-name'));");

						parsed_authors.push(parsed_author);
					}
				}
				return parsed_authors;
			},
			join_author_html(parsed_authors){
				if (parsed_authors.length == 0) {
					return "";
				}
				var out = $('<span></span>');
				for (var i = 0; i < parsed_authors.length; i++) {
					out.append(parsed_authors[i].element);
					if (i + 2 < parsed_authors.length) {
						out.append(", ");
					}
					else if (i + 1 < parsed_authors.length){
						out.append(" & ");
					}
				}
				return out.html();
			},
			taxa_build_full_name(taxa){
				var name_wrapper = "span";
				if (taxa.type == "species" || taxa.type == "genera" || taxa.type == "synonyms") {
					name_wrapper = "i";
				}

				var name = `<${name_wrapper} class="wol-name-wrapper wol-name-wrapper-${taxa.type}">${taxa.scientific_name}</${name_wrapper}>`;
				var author_year = `<span class="wol-author-year">${taxa.authors_html}, <a href="javascript:void(0);" onclick="$(document).trigger('WOLSetYear','${taxa.year}');">${taxa.year}</a></span>`;
				if (taxa.original_genus) {
					author_year = "(" + author_year + ")";
				}

				var ret = `${name} ${author_year}`;

				if (taxa.type == "synonyms") {
					ret = "Syn " + ret;
				}

				if (taxa.original_genus) {
					if (this.taxon_exists(taxa.original_genus)) {
						ret += " [<a href=\"javascript:void(0);\" onclick=\"$(document).trigger(\'WOLSetTaxon\',\'"+taxa.original_genus+"\');\"><i>"+taxa.original_genus+"</i></a>]";
					}
					else{
						ret += " [<i>"+taxa.original_genus+"</i>]";
					}
				}
				if (taxa.qualifier) {
					ret += " ("+taxa.qualifier+")";
				}
				return ret;
			},
			taxon_exists: function(taxon){
				for (var i = this.flat_taxa.length - 1; i >= 0; i--) {
					if (this.flat_taxa[i].type == "species" || this.flat_taxa[i].type == "synonyms") {
						continue;
					}
					if (this.flat_taxa[i].scientific_name == taxon) {
						return true;
					}
				}
				return false;
			},
			getData: function(){
				var self = this;
				self.flat_taxa = [];
				this.API({
					endpoint: 'wol/taxa/tree',
					funcThen: function(response){
						self.show_all(response.data.suborders);
						self.set_parents_and_defaults(response.data.suborders);
						self.taxon_suborders = response.data.suborders;
						self.apply_filters();
						self.taxon_meta = response.data.meta;

						$.get( "/odonata-list-intro/", function( data ) {
							self.intro = self.fixIntro(data);
						});
						self.loading = false;
					},
				});
			},
			fixIntro: function(introText){
				var datestring = this.taxon_meta.updated_at;
				var dparts = datestring.split('-');
				var monthIndex = parseInt(dparts[1]) - 1;
				var date = new Date(dparts[0],monthIndex,dparts[2]);
				var now = new Date();
				return introText
				.replace("{{updated_date}}", this.$options.filters.moment(date, this.momentDisplayFormat()))
				.replace("{{species_count}}", this.taxon_meta.valid_species)
				.replace("{{current_date}}", this.$options.filters.moment(now, this.momentDisplayFormat()))
				.replace("{{current_year}}", now.getFullYear())
				;
			},
			downloadExcelData:function(){
				window.open(
					this.APIFullURL({
						endpoint: 'taxonworks/taxa/download/xlsx',
					})
					);
			},
			downloadCSVData:function(){
				window.open(
					this.APIFullURL({
						endpoint: 'taxonworks/taxa/download/csv',
					})
					);
			},
		},
		computed: {
			show_hierarchy:{
				get: function(){
					if (this.selected_author || this.selected_year) {
						return false;
					}
					return true;
				}
			},
			show_hierarchy_context:{
				get: function(){
					if (this.selected_author || this.selected_year) {
						return false;
					}
					return true;
				}
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/pages/TaxonomyList.vue